import { useExternalLink, linkHost } from "./externalLink";
import { useDialogA11y } from "./useDialogA11y";

// 전역 1회 마운트(App). 외부 이동 요청 시 고지 모달(FR-COM-04).
export function ExternalLinkDialog() {
  const pending = useExternalLink((s) => s.pending);
  const confirm = useExternalLink((s) => s.confirm);
  const cancel = useExternalLink((s) => s.cancel);

  return pending ? <Dialog onCancel={cancel} onConfirm={confirm} host={linkHost(pending)} /> : null;
}

function Dialog({
  onCancel,
  onConfirm,
  host,
}: {
  onCancel: () => void;
  onConfirm: () => void;
  host: string;
}) {
  const ref = useDialogA11y<HTMLDivElement>(onCancel); // ESC 닫기 + 초기 포커스
  return (
    <div
      ref={ref}
      className="ext-backdrop"
      role="dialog"
      aria-modal="true"
      aria-label="외부 사이트 이동 안내"
      onClick={(e) => {
        if (e.target === e.currentTarget) onCancel();
      }}
    >
      <div className="ext-dialog">
        <h2 className="ext-dialog__title">외부 사이트로 이동합니다</h2>
        <p className="ext-dialog__host">{host}</p>
        <p className="ext-dialog__note">
          새 창에서 외부 사이트가 열려요. 계속할까요?
        </p>
        <div className="ext-dialog__actions">
          <button type="button" className="btn" onClick={onCancel}>
            취소
          </button>
          <button type="button" className="btn btn--primary" onClick={onConfirm}>
            이동하기 ↗
          </button>
        </div>
      </div>
    </div>
  );
}
